import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import LeaderboardPage from './pages/LeaderboardPage'
import AdminPage from './pages/AdminPage'

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/palmares" replace />} />
        <Route path="/palmares" element={<LeaderboardPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="*" element={<Navigate to="/palmares" replace />} />
      </Routes>
    </BrowserRouter>
  )
}
